module.exports = __webpack_public_path__ + "assets/img/loyalty-3.0e3df4c4.svg";